import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import Link from 'view/common/elements/link';
import { PencilIcon, TrashIcon, InformationCircleIcon } from '@heroicons/react/solid'
import Popover from 'view/common/elements/popover';
import httpClient from 'httpClient';


const ResourceLink = (props) => {
  
  const [popOverOpen, setPopOverOpen] = useState(false);
  const [undoVisible, setUndoVisible] = useState(false);
  const [deleteInProgress, setDeleteInProgress] = useState(false);
  const [opacityClass, setOpacityClass] = useState('');

  const {index, link} = {index:1,...props};
  const maxLength = 75;
  const iconClasses = `text-uhblue-darkest inline-block cursor-pointer ml-2 h-5 w-5 inline-block`
  const truncatedLink 
  = props.link.url.length > maxLength ? link.url.substring(0, maxLength)+"..." : link.url;

  // const onLinkDeleted = () => {
  //     try {
  
  //       // props.onLinkDeleted(link.id)
  //     } catch (ex) {
  
  //     } finally {

  //     }
    
  // }
  useEffect(()=>{
    if(undoVisible) {
      setOpacityClass('opacity-50')
    } else {
      setOpacityClass('')
    }
  },[undoVisible])
  const toggleLinkDelete = async (deleted=true) => {
    if(deleteInProgress) {
      return;
    }
    setDeleteInProgress(true);
    try {
      
      const response = await httpClient.post("/administration/v1/toggleLinkDelete", {
        id: link.id,
        deleted: deleted
      });
      if(!response.Error) {
        if(deleted) {
          setUndoVisible(true);
        } else {
          setUndoVisible(false);
        }
      }
      
    } catch (ex) {

    } finally {
      setDeleteInProgress(false);
    }
    
  }
  
  return ( 
    <div className={`flex justify-between ${opacityClass}`}>
      <div className='mr-1'>{`${index}.`}</div>
      <div className='grow-1' style={{flexGrow:1}}>
        <a
          href={link.url}
          target={'_blank'}
          className={`blue underline font-bold text-xs`}
          rel="noreferrer"
        >
        {truncatedLink}
        </a>
      </div>
      { !undoVisible &&
        <div>
          { link.description !== null && link.description.trim() !== "" &&
          <Popover
              content={link.description.trim()}
              isPopOverOpen={popOverOpen}
            >
              <span 
                className={iconClasses} 
                onClick={() => {}}
                onMouseEnter={() => setPopOverOpen(true)} 
                onMouseLeave={() => setPopOverOpen(false)} 
              >
                <InformationCircleIcon/>
              </span>
            </Popover>
          }
          
          <span className={iconClasses} onClick={()=>{props.onLinkEdit(link)}}>
            <PencilIcon/>
          </span>
          <span className={iconClasses} onClick={() => toggleLinkDelete(true)}>
            <TrashIcon/>
          </span>
        </div>
      }
      { undoVisible &&
        <Link
          text={`Undo`}
          onClick={() => toggleLinkDelete(false)}
        />
      }
    </div>
  ) 
}
Link.propTypes = {
  link: PropTypes.object.isRequired,
}
export default ResourceLink;